"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.23.0
 */
'use client';

import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import '../../../styled-system/css/css.mjs';
import '../../../styled-system/helpers.mjs';
import '../../../styled-system/jsx/is-valid-prop.mjs';
import { Flex } from '../../../styled-system/jsx/flex.mjs';
import '../../../styled-system/patterns/visually-hidden.mjs';
import { DropdownUI } from '../../DropdownUI/index.mjs';
import { SvgIcon } from '../../SvgIcon/index.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { useComboBox } from '../context/combobox-context.mjs';
import { useComboBoxDropdownContext } from '../context/combobox-dropdown-context.mjs';
import { useComboBoxDropdownSearchContext } from '../context/combobox-dropdown-search.mjs';
import { dropdownCategoryConfig } from '../shared.mjs';

const SearchInput = forwardRef(({ autoFocus }, ref) => {
  const { activeCategory } = useComboBoxDropdownContext();
  const { hideSearch } = useComboBoxDropdownSearchContext();
  if (activeCategory && dropdownCategoryConfig[activeCategory]?.hideSearchInput) {
    return null;
  }
  if (hideSearch) {
    return null;
  }
  return /* @__PURE__ */ jsx(DropdownSearchComponent, { autoFocus, ref });
});
const DropdownSearchComponent = forwardRef(({ autoFocus }, ref) => {
  const { value: parentInputValue, onValueChange: setParentValue } = useComboBox();
  const { canUseParentInputSearchValue } = useComboBoxDropdownContext();
  const { dropdownSearchInputValue, setDropdownSearchInputValue, setSearchSource } = useComboBoxDropdownSearchContext();
  const hasParentInputSearch = !!parentInputValue && typeof parentInputValue === "string" && canUseParentInputSearchValue;
  const hasDropdownInputSearch = dropdownSearchInputValue && typeof dropdownSearchInputValue === "string";
  const hasSearchValue = hasParentInputSearch || hasDropdownInputSearch;
  const handleClear = () => {
    if (hasParentInputSearch) {
      setParentValue?.("");
    }
    if (hasDropdownInputSearch) {
      setDropdownSearchInputValue("");
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Flex, { dir: "row", gap: "0", justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ jsx(
        DropdownUI.Search,
        {
          ref,
          value: dropdownSearchInputValue,
          onChange: setDropdownSearchInputValue,
          autoFocus,
          placeholder: canUseParentInputSearchValue ? parentInputValue : void 0,
          onFocus: () => setSearchSource("dropdown-search-input")
        }
      ),
      hasSearchValue && /* @__PURE__ */ jsx(DropdownUI.ClearSearchButton, { onClick: handleClear, children: /* @__PURE__ */ jsx(SvgIcon, { type: SvgIconType.Close }) })
    ] }),
    /* @__PURE__ */ jsx(DropdownUI.SearchDivider, {})
  ] });
});

export { SearchInput };
